import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body text-center" }
const _hoisted_11 = { class: "fw_700 my-2" }
const _hoisted_12 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_14 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-body text-center" }
const _hoisted_19 = { class: "fw_700 my-2" }
const _hoisted_20 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_22 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = { class: "card-body text-center" }
const _hoisted_28 = { class: "fw_700 my-2" }
const _hoisted_29 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_31 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-body text-center" }
const _hoisted_36 = { class: "fw_700 my-2" }
const _hoisted_37 = {
  key: 0,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_39 = {
  key: 1,
  class: "custom-fs-14",
  style: {"color":"#666"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = { class: "col-sm-12" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = { class: "card-body text-center" }
const _hoisted_45 = { class: "row mb-3" }
const _hoisted_46 = { class: "col-sm-3" }
const _hoisted_47 = { class: "card h-100" }
const _hoisted_48 = { class: "card-body text-center d-flex align-items-center justify-content-center" }
const _hoisted_49 = { class: "col-sm-9" }
const _hoisted_50 = { class: "card" }
const _hoisted_51 = { class: "card-body text-center" }
const _hoisted_52 = { class: "row mb-3" }
const _hoisted_53 = { class: "col-sm-9" }
const _hoisted_54 = { class: "card" }
const _hoisted_55 = { class: "card-body text-center" }
const _hoisted_56 = { class: "col-sm-3" }
const _hoisted_57 = { class: "card h-100" }
const _hoisted_58 = { class: "card-body text-center d-flex align-items-center justify-content-center" }
const _hoisted_59 = { class: "row mb-3" }
const _hoisted_60 = { class: "col-sm-12" }
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "card-body text-center" }
const _hoisted_63 = { class: "row mb-3" }
const _hoisted_64 = { class: "col-sm-12" }
const _hoisted_65 = { class: "card" }
const _hoisted_66 = { class: "card-body" }
const _hoisted_67 = { class: "table table-striped mb-0" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { colspan: "2" }
const _hoisted_70 = { class: "py-2" }
const _hoisted_71 = {
  key: 1,
  class: "text-center pt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_chart = _resolveComponent("chart")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_bar_chart_horizontal = _resolveComponent("bar-chart-horizontal")!

  return (_ctx.loaded && _ctx.availableYears.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.availableYears,
              modelValue: _ctx.selectedYear,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              labelKey: "Time period",
              labelValue: "Time period",
              placeholderKey: "Select a time period",
              placeholderValue: "Select a time period",
              onChange: _ctx.updateTimePeriod
            }, null, 8, ["list", "modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "Results visualization",
              text: "Results visualization",
              class: "d-block mb-2 pb-1 fw_700"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn w-50 justify-content-center me-2", !_ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tonnesVisualization = false))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Kg",
                  text: "Kg"
                })
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["btn w-50 justify-content-center", _ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tonnesVisualization = true))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Tonnes",
                  text: "Tonnes"
                })
              ], 2)
            ])
          ])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Consolidated Emissions",
                  text: "Consolidated Emissions",
                  class: "fw_700"
                }),
                _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.overviewModel.totalEmissions, _ctx.tonnesVisualization))), 1),
                (!_ctx.tonnesVisualization)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode("(Kg CO"),
                      _hoisted_13,
                      _createTextVNode("e)")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode("(Tonnes CO"),
                      _hoisted_15,
                      _createTextVNode("e)")
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-01 (Direct Emissions)",
                  text: "Scope-01 (Direct Emissions)",
                  class: "fw_700"
                }),
                _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.overviewModel.totalEmissionsScope1, _ctx.tonnesVisualization))), 1),
                (!_ctx.tonnesVisualization)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode("(Kg CO"),
                      _hoisted_21,
                      _createTextVNode("e)")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createTextVNode("(Tonnes CO"),
                      _hoisted_23,
                      _createTextVNode("e)")
                    ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-02 (Indirect Emissions)",
                  text: "Scope-02 (Indirect Emissions)",
                  class: "fw_700"
                }),
                _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.overviewModel.totalEmissionsScope2, _ctx.tonnesVisualization))), 1),
                (!_ctx.tonnesVisualization)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                      _createTextVNode("(Kg CO"),
                      _hoisted_30,
                      _createTextVNode("e)")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                      _createTextVNode("(Tonnes CO"),
                      _hoisted_32,
                      _createTextVNode("e)")
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Scope-03 (Other Indirect Emissions)",
                  text: "Scope-03 (Other Indirect Emissions)",
                  class: "fw_700"
                }),
                _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.overviewModel.totalEmissionsScope3, _ctx.tonnesVisualization))), 1),
                (!_ctx.tonnesVisualization)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _createTextVNode("(Kg CO"),
                      _hoisted_38,
                      _createTextVNode("e)")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _createTextVNode("(Tonnes CO"),
                      _hoisted_40,
                      _createTextVNode("e)")
                    ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                (_openBlock(), _createBlock(_component_line_chart, {
                  dataDictionary: _ctx.emissionsByMonth,
                  key: _ctx.lineChartKey,
                  weightLabel: _ctx.tonnesVisualization ? 'Tonnes CO2e' : 'kg CO2e'
                }, null, 8, ["dataDictionary", "weightLabel"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(), _createBlock(_component_chart, {
                  summaryChartVM: _ctx.scopePercentagePieChart,
                  legendPosition: 'bottom',
                  resizeChart: false,
                  key: _ctx.pieChartKey
                }, null, 8, ["summaryChartVM"]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_openBlock(), _createBlock(_component_bar_chart, {
                  dataDictionary: _ctx.premisesEmissionsByScopes,
                  key: _ctx.premises_barChartKey,
                  managingScopes: true,
                  colors: _ctx.premisesColors
                }, null, 8, ["dataDictionary", "colors"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                (_openBlock(), _createBlock(_component_bar_chart, {
                  dataDictionary: _ctx.scopesEmissionsByPremises,
                  key: _ctx.scopes_barChartKey,
                  colors: _ctx.premisesColors
                }, null, 8, ["dataDictionary", "colors"]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                (_openBlock(), _createBlock(_component_chart, {
                  class: "w-100",
                  summaryChartVM: _ctx.premisesPercentagePieChart,
                  legendPosition: 'bottom',
                  key: _ctx.pieChartKey
                }, null, 8, ["summaryChartVM"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                (_openBlock(), _createBlock(_component_bar_chart_horizontal, {
                  dataDictionary: _ctx.categoriesEmissionsByPremises,
                  key: _ctx.barChartHorizontalKey,
                  colors: _ctx.premisesColors
                }, null, 8, ["dataDictionary", "colors"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("table", _hoisted_67, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Premises type",
                          text: "Premises type"
                        })
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.tonnesVisualization)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 0,
                              localizedKey: "Tonnes CO2e",
                              text: "Tonnes CO2e"
                            }))
                          : (_openBlock(), _createBlock(_component_localized_text, {
                              key: 1,
                              localizedKey: "Kg CO2e",
                              text: "Kg CO2e"
                            }))
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.overviewModel.premisesTotals.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                          _createElementVNode("td", _hoisted_69, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "No Elements Found",
                              text: "No Elements Found"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.overviewModel.premisesTotals as OM.KeyValuePairOfStringAndDouble[]), (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", null, _toDisplayString(item.key), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(item.value, _ctx.tonnesVisualization))), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_71, [
        _createVNode(_component_localized_text, {
          localizedKey: "No data yet",
          text: "No data yet",
          class: "d-block mb-2 pb-1 fw_700"
        }),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/activity-data-recorder')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add new activity",
            text: "Add new activity"
          })
        ])
      ]))
}